import React, { useState } from 'react'
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"

import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { toast } from "@/components/ui/use-toast"
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useDispatch } from 'react-redux'
import { UpdateBookingPaymentInfo } from '../actions/flightAction'
import { useNavigate } from 'react-router-dom'
import { Paths } from '../constants/Paths'

const FormSchema = z.object({
  transId: z.string().min(2, {
    message: "Reference Code is required",
  }),
})
const CustmomPaymentList = ({ reservationResp }) => {
  const { Pricing } = reservationResp;

  const [showStep3, setShowStep3] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      transId: "",
    },
  })
  function onSubmit(data) {
    let payload = {
      PaymentTranID: data.transId,
      BookingRef: localStorage.bookinfRef
    }
    dispatch(UpdateBookingPaymentInfo(payload, (resp) => {
      if (resp.IsSuccess) {
        setIsFormSubmitted(true);
      }
      toast({
        variant: resp.IsSuccess ? "success" : "destructive",
        title: resp.IsSuccess ? "Code submitted" : "Error",
        description: resp.Message,
      });

    }))
    setShowStep3(true);
  }
  return (
    <div className="p-4 max-w-xl mx-auto dark:bg-gray-800">

      <h2 className="font-heading dark:text-gray-100 mb-8 text-2xl font-bold lg:text-3xl">Steps for QR Payment
      </h2>

      <div className="flex">
        <div className="mr-4 flex flex-col items-center">
          <div>
            <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-primary"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              className="h-6 w-6 text-primary dark:text-slate-200">
              <path d="M12 5l0 14"></path>
              <path d="M18 13l-6 6"></path>
              <path d="M6 13l6 6"></path>
            </svg></div>
          </div>
          <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
        </div>
        <div className="pt-1 pb-8">
          <p className="mb-2 text-xl font-bold text-gray-900 dark:text-slate-300">Step 1</p>
          <p className="text-gray-600 dark:text-slate-400">Scan the given QR Code, enter you <b>PNR Code</b> on <b>Payment Remarks</b> field and pay <b>{Pricing.Currency}. {Pricing.GTotalFare}</b>. You can either keep a <b>screenshot</b> or <b>download</b> the transaction details. The information present there will be <b>required</b> on following steps.</p>
        </div>
      </div>


      <div className="flex">
        <div className="mr-4 flex flex-col items-center">
          <div>
            <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-primary"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              className="h-6 w-6 text-primary dark:text-slate-200">
              <path d="M12 5l0 14"></path>
              <path d="M18 13l-6 6"></path>
              <path d="M6 13l6 6"></path>
            </svg></div>
          </div>
          {showStep3 && <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>}
        </div>
        <div className=' pt-1 pb-8'>
          <div>
            <p className="mb-2 text-xl font-bold text-gray-900 dark:text-slate-300">Step 2</p>
            <p className="text-gray-600 dark:text-slate-400">
              There is <b>Payment Reference Code</b> on your payment success page. You need to enter it below.
            </p>
          </div>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <FormField
                control={form.control}
                name="transId"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Payment Reference Code</FormLabel>
                    <FormControl>
                      <Input placeholder="Reference Code" {...field} disabled={isFormSubmitted} />
                    </FormControl>
                    <FormMessage />
                    {!isFormSubmitted && <FormDescription>Please recheck your code before submission</FormDescription>}
                  </FormItem>
                )}
              />
              <div className='flex justify-end'>
                {isFormSubmitted ? <label className='text-primary'>Reference code saved! </label> : <Button className="mt-2" type="submit">Submit</Button>}
              </div>
            </form>
          </Form>
        </div>
      </div>


      {showStep3 && <><div className="flex">
        <div className="mr-4 flex flex-col items-center">
          <div>
            <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-primary"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              className="h-6 w-6 text-primary dark:text-slate-200">
              <path d="M12 5l0 14"></path>
              <path d="M18 13l-6 6"></path>
              <path d="M6 13l6 6"></path>
            </svg></div>
          </div>
          <div className="h-full w-px bg-gray-300 dark:bg-slate-500"></div>
        </div>
        <div>
          <div className="pt-1 pb-2">
            <p className="mb-2 text-xl font-bold text-gray-900 dark:text-slate-300">Step 3</p>
            <p className="text-gray-600 dark:text-slate-400">
              The code has been submitted. We will contact you soon for ticket issue.
            </p>
          </div>
          <div className='flex justify-end'>
            <Button type="buton" onClick={() => { navigate(Paths.MY_BOOKINGS) }}>Go to MyBookings</Button>
          </div>

        </div>
      </div>


        <div className="flex">
          <div className="mr-4 flex flex-col items-center">
            <div>
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-full border-2 border-primary ${isFormSubmitted ? "bg-primary" : "bg-white"} `}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  className={`h-6 w-6 ${isFormSubmitted ? "text-white" : "text-primary"} dark:text-slate-200`}>
                  <path d="M5 12l5 5l10 -10"></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="pt-1 ">
            <p className="mb-2 text-xl font-bold text-gray-900 dark:text-slate-300">Ready!</p>
          </div>
        </div>
      </>
      }

    </div>
  )
}

export default CustmomPaymentList
